import { useOutletContext } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSeo } from "../hooks/useSeo";
import { buildCanonicalUrl } from "../seo/config";
import type { LayoutOutletContext } from "../layout/types";

export const Home = () => {
  const { t } = useTranslation();
  const { locale } = useOutletContext<LayoutOutletContext>();
  const pageTitle = t("pages.home.title");
  const siteTitle = t("site.title");
  
  useSeo({
    title: `${pageTitle} | ${siteTitle}`,
    description: t("pages.home.intro"),
    canonical: buildCanonicalUrl("", locale),
    locale,
  });

  return null;
};
